<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="">
    <div class="row" v-if="user_means_paiements">
      <div class="col-12 mt-3 mb-0 pb-0">
        <v-alert type="info">
          {{ $t("usermeans.description") }}
        </v-alert>
      </div>
      <v-card class="container-fluid pt-0 elevation-0">
        <v-dialog v-model="dialogMoyen" max-width="800px" class="elevation-0">
          <template v-slot:activator="{ on }">
            <v-card-title style="padding: 0 !important">
              <div class="text-right col-md">
                <v-btn small color="default" dark v-on="on" @click="setdefault">
                  {{ $t("usermeans.new") }}
                </v-btn>
              </div>
            </v-card-title>
          </template>
          <v-card elevation="0">
            <v-card-title>
              <v-col md="11" lg="11" sm="11">
                <span class="headline"> {{ $t("usermeans.title") }} </span>
              </v-col>
              <v-col md="1" lg="1" sm="1">
                <v-icon style="cursor: pointer" @click="setdefaultClose()">
                  mdi-close</v-icon
                >
              </v-col>
            </v-card-title>
            <v-card-text>
              <!-- <v-alert v-if="editedIndex <= -1" class="col-12" type="warning" >
                                {{$t('usermeans.alert')}}
                            </v-alert>-->
              <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                <v-stepper v-model="e1" elevation="0">
                  <v-stepper-header class="elevation-0">
                    <v-stepper-step :complete="e1 > 1" step="1"
                      >{{ $t("usermeans.tm") }}
                    </v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step :complete="e1 > 2" step="2"
                      >{{ $t("usermeans.mc") }}
                    </v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step step="3"
                      >{{ $t("usermeans.tm") }}
                    </v-stepper-step>
                  </v-stepper-header>

                  <v-stepper-items>
                    <v-stepper-content step="1">
                      <div class="row">
                        <div
                          class="col-12 col-md-6 col-lg-6"
                          style="text-align: center"
                        >
                          <v-card
                            @click="chooseItem('Mobile')"
                            id="Mobile"
                            class="ma-3 pa-6 chooseAll"
                            outlined
                            tile
                            :style="
                              getBackColor('Mobile') + 'text-align: center;'
                            "
                          >
                            <img
                              src="images/phonemode.svg"
                              width="120"
                              alt=""
                              style="padding: 2.5%"
                            />
                            <h3
                              style="margin-top: 5%; font-weight: bold"
                              class="text-uppercase"
                            >
                              {{ $t("usermeans.mobile") }}
                            </h3>
                          </v-card>
                        </div>
                        <div
                          class="col-12 col-md-6 col-lg-6"
                          style="text-align: center"
                        >
                          <v-card
                            @click="chooseItem('Banque')"
                            id="Banque"
                            class="ma-3 pa-6 chooseAll"
                            outlined
                            tile
                            :style="
                              getBackColor('Banque') + 'text-align: center;'
                            "
                          >
                            <img
                              src="images/bankmode2.png"
                              width="120"
                              alt=""
                            />
                            <h3
                              style="margin-top: 5%; font-weight: bold"
                              class="text-uppercase"
                            >
                              {{ $t("usermeans.bancaire") }}
                            </h3>
                          </v-card>
                        </div>
                      </div>

                      <div class="text-right container">
                        <v-btn
                          elevation="0"
                          color="primary"
                          @click="e1 = 2"
                          :disabled="!step1"
                        >
                          {{ $t("continuer") }}
                        </v-btn>
                      </div>
                    </v-stepper-content>

                    <v-stepper-content step="2">
                      <div class="row" v-if="means_paiements">
                        <v-alert
                          class="col-12"
                          type="warning"
                          v-if="means_paiements.length === 0"
                        >
                          {{ $t("usermeans.no_data") }}
                        </v-alert>
                        <div
                          class="col-12 col-md-4 col-lg-4"
                          v-for="(n, index) in means_paiements"
                          :key="index"
                          style="text-align: center"
                        >
                          <v-card
                            @click="
                              chooseMeans(
                                n._id,
                                JSON.stringify(n._prefixes),
                                n._country._code_iso_numerique
                              )
                            "
                            class="ma-3 pa-6 chooseAllMoyen"
                            outlined
                            tile
                            :style="
                              getBackColorMeans(n._id) + 'text-align: center;'
                            "
                            :id="n._id"
                          >
                            <img
                              v-if="n._file"
                              :src="n._file.substr(7)"
                              alt=""
                              width="80px"
                              class="mb-2"
                            />
                            <h6
                              style="
                                margin-top: 5%;
                                font-weight: bold;
                                font-size: 9pt;
                              "
                              class="text-uppercase"
                            >
                              {{ n._name }} ( {{ n._country._name }} )
                            </h6>
                          </v-card>
                        </div>
                      </div>
                      <div class="text-right container">
                        <div class="offset-md-7 col-md-5">
                          <div class="row">
                            <div class="col-md-6" style="padding: 2px">
                              <v-btn
                                class="dark"
                                text
                                @click="e1 = 1"
                                elevation="0"
                                >{{ $t("return") }}
                              </v-btn>
                            </div>
                            <div class="col-md-6" style="padding: 2px">
                              <v-btn
                                elevation="0"
                                color="primary"
                                @click="e1 = 3"
                                :disabled="!step2"
                              >
                                {{ $t("continuer") }}
                              </v-btn>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-stepper-content>

                    <v-stepper-content step="3">
                      <v-alert
                        v-if="errors"
                        dense
                        outlined
                        :type="errors.update_error ? 'error' : 'success'"
                      >
                        {{ $t(errors.operation) }}
                      </v-alert>

                      <v-text-field
                        v-if="submitting"
                        color="primary"
                        loading
                        disabled
                      ></v-text-field>
                      <v-row>
                        <v-col cols="12">
                          <h6 style="color: #29b3a6">
                            {{ $t("usermeans.infotitle") }}
                          </h6>
                          <v-row>
                            <v-col cols="6">
                              <label for="">{{
                                $t("usermeans.account_name")
                              }}</label>
                              <v-text-field
                                solo
                                small
                                @keyup="validestep(3)"
                                :rules="account_nameRules"
                                v-model="editedItem._account_name"
                                label="Ex: Doe"
                              ></v-text-field>
                              <div
                                class="pt-0"
                                style="color: #b71c1c"
                                v-if="errors_name != null"
                              >
                                {{ errors_name }}
                              </div>
                            </v-col>

                            <v-col cols="6">
                              <label for="">{{
                                $t("usermeans.account_surname")
                              }}</label>
                              <v-text-field
                                solo
                                small
                                @keyup="validestep(3)"
                                :rules="account_surnameRules"
                                v-model="editedItem._account_surname"
                                label="EX: John"
                              ></v-text-field>
                              <div
                                class="pt-0"
                                style="color: #b71c1c"
                                v-if="errors_surname != null"
                              >
                                {{ errors_surname }}
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>

                        <v-col cols="12" class="mt-0 pt-0">
                          <v-row>
                            <v-col
                              cols="12"
                              md="4"
                              v-if="type == 'Banque'"
                              class="pt-0 mt-0"
                            >
                              <label for="">{{ $t("usermeans.swift") }}</label>
                              <v-text-field
                                solo
                                small
                                @keyup="validestep(3)"
                                :rules="swiftRules"
                                v-model="editedItem._swift"
                                :label="$t('usermeans.swift')"
                              ></v-text-field>
                              <div
                                class="pt-0"
                                style="color: #b71c1c"
                                v-if="errors_swift != null"
                              >
                                {{ errors_swift }}
                              </div>
                            </v-col>
                            <v-col
                              cols="12"
                              md="8"
                              class="pt-0 mt-0"
                              v-if="type === 'Banque'"
                            >
                              <label for="">IBAN</label>
                              <v-text-field
                                solo
                                small
                                @keyup="validestep(3)"
                                :rules="account_numberRules"
                                v-model="editedItem._account_number"
                                label="EX: BJXX XXXX XXXX XXXX XXXX XXXX XXX"
                              ></v-text-field>
                              <div
                                class="pt-1"
                                style="color: #b71c1c"
                                v-if="errors_number != null"
                              >
                                {{ errors_number }}
                              </div>
                            </v-col>
                            <!--   <v-col cols="2" v-if="type == 'Banque'">
                              <label for="">{{ $t("usermeans.rib") }}</label>
                              <v-text-field
                                solo
                                small
                                @keyup="validestep(3)"
                                :rules="ribRules"
                                v-model="editedItem._rib"
                                :label="$t('usermeans.rib')"
                              ></v-text-field>
                              <div
                                class="pt-1"
                                style="color: #b71c1c"
                                v-if="errors_rib != null"
                              >
                                {{ errors_rib }}
                              </div>
                            </v-col> -->
                          </v-row>
                        </v-col>

                        <v-col
                          cols="12"
                          class="pt-0 mt-0"
                          v-if="type === 'Mobile'"
                        >
                          <label for="">{{ $t("usermeans.num_tel") }}</label>
                          <v-text-field
                            solo
                            small
                            @keyup="validestep(3)"
                            :rules="account_numberRules"
                            v-model="editedItem._account_number"
                            label="Ex: 2290167000000"
                          ></v-text-field>
                          <div
                            class="pt-0"
                            style="color: #b71c1c"
                            v-if="errors_number != null"
                          >
                            {{ errors_number }}
                          </div>
                        </v-col>
                      </v-row>

                      <div class="text-right container">
                        <div class="offset-md-7 col-md-5">
                          <div class="row">
                            <div class="col-md-6" style="padding: 2px">
                              <v-btn class="dark" text @click="e1 = 2"
                                >{{ $t("return") }}
                              </v-btn>
                            </div>
                            <div class="col-md-6" style="padding: 2px">
                              <v-btn
                                color="primary"
                                @click.prevent="save"
                                :disabled="!step3"
                              >
                                {{ $t("save") }}
                              </v-btn>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-stepper-content>
                  </v-stepper-items>
                </v-stepper>
              </v-form>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDetail" max-width="600px" v-if="selectedItem">
          <v-card>
            <v-card-title>
              <v-col md="11" lg="11" sm="11">
                <span class="headline"> {{ $t("usermeans.detailinfo") }} </span>
              </v-col>
              <v-col md="1" lg="1" sm="1">
                <v-icon style="cursor: pointer" @click="dialogDetail = false">
                  mdi-close</v-icon
                >
              </v-col>
            </v-card-title>
            <v-card-text>
              <table style="width: 100%" class="p-3 table table-striped">
                <tbody>
                  <tr style="padding: 15px">
                    <td style="padding: 15px">
                      {{ $t("usermeans.account_name2") }}:
                    </td>
                    <td>
                      {{ selectedItem._account_name }}
                      {{ selectedItem._account_surname }}
                    </td>
                  </tr>

                  <tr style="padding: 15px">
                    <td style="padding: 15px">
                      {{ $t("usermeans.typeUsermeans") }}:
                    </td>
                    <td>{{ selectedItem._type }}</td>
                  </tr>

                  <tr style="padding: 15px">
                    <td style="padding: 15px">
                      {{ $t("usermeans.means_paiement") }}:
                    </td>
                    <td>
                      <div class="row">
                        <div class="col-md-3">
                          <a
                            v-if="selectedItem._means_paiement._file"
                            href="javascript:void(0)"
                          >
                            <v-img
                              :lazy-src="
                                selectedItem._means_paiement._file.substr(7)
                              "
                              max-height="50"
                              max-width="70"
                              :src="
                                selectedItem._means_paiement._file.substr(7)
                              "
                            ></v-img>
                          </a>
                        </div>
                        <div class="col-md-8">
                          <div class="mt-2">
                            {{ selectedItem._means_paiement._name }}
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr style="padding: 15px">
                    <td style="padding: 15px">
                      {{ $t("usermeans.account_number") }}:
                    </td>
                    <td>{{ selectedItem._account_number }}</td>
                  </tr>

                  <tr
                    style="padding: 15px"
                    v-if="selectedItem._type == 'Banque'"
                  >
                    <td style="padding: 15px">{{ $t("usermeans.swift") }}:</td>
                    <td>{{ selectedItem._swift }}</td>
                  </tr>
                  <tr
                    style="padding: 15px"
                    v-if="selectedItem._type == 'Banque'"
                  >
                    <td style="padding: 15px">{{ $t("usermeans.rib") }}:</td>
                    <td>{{ selectedItem._rib }}</td>
                  </tr>
                </tbody>
              </table>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-tabs v-model="api_tabs" style="background: #616161 !important">
          <v-tab>{{ $t("usermeans.myusemeansactive") }}</v-tab>
          <v-tab>{{ $t("usermeans.myusemeansdisactive") }}</v-tab>
        </v-tabs>
        <v-tabs-items
          v-model="api_tabs"
          style="background: transparent !important"
        >
          <v-tab-item>
            <v-data-table
              :headers="headers"
              :items="user_means_paiements"
              :search="search"
              sort-by="name"
              class="elevation-1"
              :loading="user_means_paiements == undefined"
              loading-text="Chargement en cours..."
            >
              <template v-slot:item._means_paiement._file="{ item }">
                <a
                  v-if="item._means_paiement._file"
                  href="javascript:void(0)"
                  @click="
                    showImage(
                      '/' + item._means_paiement._file.substr(7),
                      item._name,
                      'img'
                    )
                  "
                >
                  <v-img
                    :lazy-src="item._means_paiement._file.substr(7)"
                    max-width="50"
                    :src="item._means_paiement._file.substr(7)"
                  ></v-img>
                </a>
              </template>

              <template v-slot:item._account_name="{ item }">
                {{ item._account_name }} {{ item._account_surname }}
              </template>

              <template v-slot:item._type="{ item }">
                <v-chip :color="getColor(item._type)" dark>{{
                  item._type
                }}</v-chip>
              </template>
              <template v-slot:item._created_at="{ item }">
                {{ getDate(item._created_at) }}
              </template>

              <template v-slot:item.actions="{ item }">
                <div style="text-align: right">
                  <v-menu key="text" rounded="b-xl">
                    <template v-slot:activator="{ attrs, on }">
                      <v-icon class="black--text" v-bind="attrs" v-on="on"
                        >mdi-dots-vertical
                      </v-icon>
                    </template>
                    <v-list>
                      <v-list-item
                        v-for="(action_item, index) in actions_items"
                        :key="index"
                        link
                        @click="editItemAction(item, index)"
                      >
                        <v-list-item-icon>
                          <v-icon color="#29B3A6">{{
                            action_item.avatar
                          }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title
                            v-text="action_item.title"
                          ></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </template>

              <template v-slot:no-data>
                {{ $t("no_data") }}
              </template>
            </v-data-table>
          </v-tab-item>
          <v-tab-item>
            <v-data-table
              :headers="headers"
              :items="user_means_paiementinactifs"
              :search="search"
              sort-by="name"
              class="elevation-1"
              :loading="user_means_paiements == undefined"
              loading-text="Chargement en cours..."
            >
              <template v-slot:item._means_paiement._file="{ item }">
                <a
                  v-if="item._means_paiement._file"
                  href="javascript:void(0)"
                  @click="
                    showImage(
                      '/' + item._means_paiement._file.substr(7),
                      item._name,
                      'img'
                    )
                  "
                >
                  <v-img
                    :lazy-src="item._means_paiement._file.substr(7)"
                    max-height="50"
                    max-width="70"
                    :src="item._means_paiement._file.substr(7)"
                  ></v-img>
                </a>
              </template>

              <template v-slot:item._account_name="{ item }">
                {{ item._account_name }} {{ item._account_surname }}
              </template>

              <template v-slot:item._type="{ item }">
                <v-chip :color="getColor(item._type)" dark>{{
                  item._type
                }}</v-chip>
              </template>
              <template v-slot:item._created_at="{ item }">
                {{ getDate(item._created_at) }}
              </template>

              <template v-slot:item.actions="{ item }">
                <div style="text-align: right">
                  <v-menu key="text" rounded="b-xl">
                    <template v-slot:activator="{ attrs, on }">
                      <v-icon class="black--text" v-bind="attrs" v-on="on"
                        >mdi-dots-vertical
                      </v-icon>
                    </template>
                    <v-list>
                      <v-list-item
                        v-for="(action_item, index) in actions_items"
                        :key="index"
                        link
                        @click="editItemAction(item, index)"
                      >
                        <v-list-item-icon>
                          <v-icon color="#29B3A6">{{
                            action_item.avatar
                          }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title
                            v-text="action_item.title"
                          ></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </template>

              <template v-slot:no-data>
                {{ $t("no_data") }}
              </template>
            </v-data-table>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </div>

    <div
      v-else
      class="col-lg-12 col-md-12 col-12 text-center loader_panel_component"
    >
      <img src="/loaders/loader_turq.gif" alt="" /><br />
      <span class="loader_text"> Chargement en cours ... </span>
    </div>
    <v-snackbar
      v-model="customSnack.snackbar"
      :timeout="customSnack.snacktimeout"
    >
      <span :color="customSnack.snackcolor">{{ customSnack.text }}</span>

      <template v-slot:action="{ attrs }">
        <v-btn
          :color="customSnack.snackcolor"
          text
          v-bind="attrs"
          @click="customSnack.snackbar = false"
        >
          {{ $t("fermer") }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState } from "vuex";
import * as Swal from "sweetalert2";
import $ from "jquery";
import helpers from "../../mixins/helpers";

export default {
  name: "UserMeansPaiement",
  mixins: [helpers(this)],
  data() {
    return {
      submitting: false,
      customSnack: {
        snackbar: false,
        text: "",
        snackcolor: "black",
        snackbBtnColor: "white",
        snacktimeout: 2000,
      },
      valid: true,
      api_tabs: null,
      lazy: false,
      step1: false,
      step2: false,
      step3: false,
      errors: undefined,
      search: "",
      dialog: "",
      type: "",
      itemMoyen: "",
      e1: 1,
      dialogMoyen: "",
      dialogDetail: false,
      selectedItem: undefined,
      id: undefined,
      errors_rib: null,
      errors_name: null,
      errors_surname: null,
      errors_swift: null,
      errors_number: null,
      actions_items: [
        {
          title: this.$t("means_paiement.detail"),
          avatar: "mdi-information-variant",
        },
        { title: this.$t("means_paiement.update2"), avatar: "mdi-pencil" },
        { title: this.$t("means_paiement.delete"), avatar: "mdi-delete" },
      ],
      headers: [
        { text: "Image descriptif", value: "_means_paiement._file" },
        { text: "Moyen de paiement", value: "_means_paiement._name" },
        { text: "Nom du compte", value: "_account_name" },
        {
          text: "Type",
          align: "start",
          sortable: false,
          value: "_type",
        },
        { text: "Numéro du compte", value: "_account_number" },
        { text: "Date", value: "_created_at" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      editedIndex: -1,
      editedItem: {
        _swift: "",
        _account_name: "",
        _account_surname: "",
        _account_number: "",
        _rib: "",
        _means_paiement: "",
        _user: "",
        _id: 0,
      },
      defaultItem: {
        _swift: "",
        _account_name: "",
        _account_surname: "",
        _account_number: "",
        _rib: "",
        _means_paiement: "",
        _user: "",
        _id: 0,
      },
      checkPrefixes: [],
      strPrefixes: "",
      swiftRules: [
        (v) => !!v || "Swift requis ",
        // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
      account_nameRules: [(v) => !!v || "Nom de compte requis"],
      account_surnameRules: [(v) => !!v || "Prénom de compte requis"],
      account_numberRules: [(v) => !!v || "Numéro du compte requis"],
      ribRules: [(v) => !!v || "Rib requis"],
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? this.$t("Nouvelle Marchand")
        : this.$t("Modifier Marchand");
    },
    ...mapState("user_means_paiements/", [
      "user_means_paiements",
      "user_means_paiementinactifs",
    ]),
    ...mapState("means_paiements/", ["means_paiements"]),
  },
  mounted() {
    this.initialize();
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogMoyen(val) {
      val || this.close();
    },
  },
  methods: {
    initialize() {
      this.$store.dispatch("countries/getCountries").then(() => {});
      this.$store.dispatch("means_paiements/getMeans_paiements").then(() => {});

      let data = new FormData();
      data.append("id", this.$store.getters.marchand._id);
      this.$store
        .dispatch("user_means_paiements/getUser_means_paiements", data)
        .then((response) => {
          console.log("user_means_paiements", response);
        });
      //console.log('user_means_paiements', this.user_means_paiements)
    },
    editItemAction(item, index) {
      switch (index) {
        case 0:
          this.dialogDetail = true;
          this.selectedItem = item;
          break;
        case 1:
          this.editItem(item);
          break;
        case 2:
          this.deleteItem(item);
          break;
      }
    },
    getBackColor(type) {
      $(".chooseAll").css("background-color", "");
      if (type == this.type) {
        return "background-color: rgb(0 181 164 / 16%)!important;";
      } else {
        return "";
      }
    },
    getBackColorMeans(type) {
      $(".chooseAllMoyen").css("background-color", "");
      if (type == this.itemMoyen) {
        return "background-color: rgb(0 181 164 / 16%)!important;";
      } else {
        return "";
      }
    },
    editItem(item) {
      this.customSnack.snackbar = false;
      this.step3 = true;
      this.editedIndex = 1;
      this.editedItem = Object.assign({}, item);
      this.dialogMoyen = true;
      this.chooseItem(item._type);
      this.chooseMeans(
        item._means_paiement._id,
        JSON.stringify(item._means_paiement._prefixes),
        item._means_paiement._country._code_iso_numerique
      );

      this.e1 = 3;

      console.log("index ", this.editedItem);
    },
    setdefault() {
      $(".chooseAll").css("background-color", "");
      this.customSnack.snackbar = false;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.e1 = 1;
      this.type = "";
      this.itemMoyen = "";
      this.step1 = false;
      this.step2 = false;
      this.step3 = false;
      $(".chooseAll").css("background-color", "");
      $(".chooseAllMoyen").css("background-color", "");
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    },
    setdefaultClose() {
      this.customSnack.snackbar = false;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.e1 = 1;
      this.step1 = false;
      this.step2 = false;
      this.step3 = false;
      $(".chooseAll").css("background-color", "");
      $(".chooseAllMoyen").css("background-color", "");
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
      this.dialogMoyen = false;
    },

    chooseItem(item) {
      this.type = item;

      // $(".chooseAll").css("background-color", "");
      // $("#" + item).css("background-color", "#A1C4E8");
      let data = new FormData();
      data.append("type", item);

      data.append("country", this.$store.getters.marchand.country._id);
      console.log(this.editedIndex);

      this.$store
        .dispatch("means_paiements/getMeansPaiementsForUser", data)
        .then((response) => {
          console.log("exchanges", response);
        });
      this.step1 = true;
      this.$store.watch(
        function (state) {
          console.log("state");
          console.log(state.means_paiements.means_paiements);
        },
        function () {
          //do something on data change
        },
        {
          deep: true, //add this if u need to watch object properties change etc.
        }
      );
    },
    chooseMeans(item, prefixes, codeCountry) {
      let oldPefixes = JSON.parse(prefixes);
      let newPefixes = [];
      for (let i = 0; i < oldPefixes.length; i++) {
        newPefixes[i] = oldPefixes[i]
          .toString()
          .replace(codeCountry.toString(), "");
        this.strPrefixes +=
          "/ " + oldPefixes[i].toString().replace(codeCountry.toString(), "");
      }
      this.checkPrefixes = newPefixes;

      this.itemMoyen = item;
      this.step2 = true;
      this.editedItem._means_paiement = item;
    },

    deleteItem(item) {
      this.customSnack.snackbar = false;

      Swal.fire({
        icon: "warning",
        timerProgressBar: false,
        text: this.$t("delete_warning"),
        confirmButtonText: this.$t("delete"),
        cancelButtonText: this.$t("cancel"),
        showCancelButton: true,
        cancelButtonColor: "#CCC",
        confirmButtonColor: "#29B3A6",
      }).then((result) => {
        if (result.value) {
          let data = new FormData();
          data.append("user", this.$store.getters.marchand._id);
          data.append("id", item._id);
          this.$store
            .dispatch("user_means_paiements/deleteUser_means_paiements", data)
            .then((response) => {
              this.showSnackDefault(response);
            });
        }
      });
    },

    close() {
      this.dialogMoyen = false;
      this.$nextTick(() => {
        this.marchand = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
      this.$refs.form.reset();
    },

    save() {
      this.submitting = true;
      this.step3 = false;
      //let VueBox = this;
      let data = new FormData();
      data.append("_user", this.$store.getters.marchand._id);
      data.append("_marchand_email", this.$store.getters.marchand._email);
      data.append("_marchand_company", this.$store.getters.marchand._company);
      data.append("_type", this.type);
      data.append("_account_name", this.editedItem._account_name);
      data.append("_account_surname", this.editedItem._account_surname);
      data.append("_account_number", this.editedItem._account_number);
      data.append("_means_paiement", this.editedItem._means_paiement);
      if (this.type === "Banque") {
        data.append("_swift", this.editedItem._swift);
        data.append("_rib", this.editedItem._rib);
      }

      let mineroute = "user_means_paiements/setUser_means_paiement";
      if (this.editedIndex > -1) {
        data.append("id", this.editedItem._id);
        mineroute = "user_means_paiements/setUpdateUser_means_paiement";
      }

      this.$store.dispatch(mineroute, data).then((response) => {
        this.submitting = false;
        this.step3 = true;

        if (response.data.error) {
          this.toast("error", response.data.message);
        } else {
          this.toast("success", response.data.message);
        }

        this.close();
        this.e1 = 1;
      });
    },
    validate() {
      this.$refs.form.validate();
    },
    validestep(step) {
      switch (step) {
        case 1:
          break;

        case 2:
          break;

        case 3:
          this.errors_name = null;
          this.errors_surname = null;
          this.errors_number = null;
          this.errors_swift = null;
          this.errors_rib = null;
          this.step3 = false;

          if (this.editedItem._account_name == "") {
            this.step3 = false;
            this.errors_name = this.$t("usermeans.errors_name");
          } else {
            if (this.editedItem._account_surname == "") {
              this.step3 = false;
              this.errors_surname = this.$t("usermeans.errors_surname");
            } else {
              if (
                this.editedItem._account_number == "" ||
                !/^\d+$/.test(this.editedItem._account_number)
              ) {
                this.step3 = false;
                this.errors_number = this.$t("usermeans.errors_number");
              } else {
                let pref_account = [];
                if (this.type == "Mobile") {
                  pref_account = this.editedItem._account_number.substring(
                    0,
                    this.checkPrefixes[0].length
                  );
                }

                if (
                  this.type == "Mobile" &&
                  !this.checkPrefixes.includes(pref_account)
                ) {
                  this.step3 = false;
                  this.errors_number =
                    this.$t("usermeans.errors_number3") + this.strPrefixes;
                } else {
                  let umps =
                    this.$store.state.user_means_paiements.user_means_paiements;
                  let umps2 =
                    this.$store.state.user_means_paiements
                      .user_means_paiementinactifs;
                  umps = umps.concat(umps2);
                  console.log(umps);
                  let existe = false;
                  for (let i = 0; i < umps.length; i++) {
                    if (
                      umps[i]._means_paiement._id ==
                        this.editedItem._means_paiement &&
                      this.editedItem._account_number == umps[i]._account_number
                    ) {
                      if (this.editedIndex < 1) {
                        existe = true;
                        break;
                      } else {
                        console.log(
                          "IDC",
                          umps[i]._id + " -- " + this.editedItem._id
                        );
                        if (umps[i]._id == this.editedItem._id) {
                          existe = false;
                          break;
                        } else {
                          existe = true;
                          break;
                        }
                      }
                    }
                  }

                  if (existe) {
                    this.step3 = false;
                    this.errors_number = this.$t("usermeans.errors_number2");
                  } else {
                    if (this.type == "Banque") {
                      if (this.editedItem._swift == "") {
                        this.step3 = false;
                        this.errors_swift = this.$t("usermeans.errors_swift");
                      } else {
                        this.step3 = true;
                      } /*  else {
                        if (this.editedItem._rib == "") {
                          this.step3 = false;
                          this.errors_rib = this.$t("usermeans.errors_rib");
                        } 
                        else {
                          this.step3 = true;
                        }
                      } */
                    } else {
                      this.step3 = true;
                    }
                  }
                }
              }
            }
          }

          break;
      }
    },
    isNumber(str) {
      var pattern = /^\d+$/;
      return pattern.test(str); // returns a boolean
    },
    reset() {
      this.$refs.form.reset();
    },
    checkisDashboard() {
      this.$emit("checkisDashboard", true);
    },
    fileChange() {
      console.log(this.$refs);
      this.editedItem._file = this.$refs.file.files[0];
    },
    getFileOriginalName(file) {
      return file.substr(file.lastIndexOf("/") + 1);
    },
    getColor(calories) {
      if (calories == "Banque") return "green";
      else if (calories == "Mobile") return "orange";
      else return "green";
    },
  },
  created() {
    this.checkisDashboard();
    this.initialize();
  },
};
</script>

<style scoped></style>
